<template>
  <div class="right-nav">
    <img class="right-gif" src="@/assets/images/rightNav/right-gif.gif" />
    <div class="nav-list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="nav-item transition"
        @mouseover="updateHover(index)"
        @mouseleave="mouseleave"
        @click="handleClick(item)"
      >
        <div
          class="nav-icon"
          :style="{
            backgroundImage:
              'url(' + (listHover === index ? item.hoverIcon : item.icon) + ')',
          }"
        ></div>
        <div class="nav-title">{{ item.title }}</div>
      </div>
      <div class="to-top transition" @click="toTop">
        <div class="top-icon"></div>
        {{ $t("rightNav.top") }}
      </div>
    </div>

    <div class="right-hover">
      <!-- 景区人流 -->
      <div class="hover-panel" v-if="listHover === 2">
        <div v-for="(item, index) in panelList" :key="index" class="panel-item">
          <div class="panel-title">
            {{ $t("ajaxKey") ? item[$t("ajaxKey")] : item.placeName }}
          </div>
          <div class="panel-content">
            <div class="panel-cell">
              <div class="panel-value">{{ item.scenicMaxNum }}</div>
              <div class="panel-label">{{ $t("scenery.load") }}</div>
            </div>
            <div class="panel-cell">
              <div class="panel-value">{{ item.scenicTimeMaxNum }}</div>
              <div class="panel-label">
                {{ $t("scenery.instantaneousLoad") }}
              </div>
            </div>
            <div class="panel-cell">
              <div class="panel-value">{{ item.personTimeNum }}</div>
              <div class="panel-label">{{ $t("scenery.people") }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 媒体关注 -->
      <div class="hover-qrcode" v-if="listHover === 3">
        <div v-for="(item, index) in qrList" :key="index" class="qrcode-item">
          <img class="qr-img" :src="item.img" />
          <div class="qr-tips">{{ item.tips }}</div>
          <div class="qr-label">{{ item.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPassengnum } from "@/api/index";
export default {
  data() {
    return {
      listHover: null,
      panelList: [
        {
          backgroundColor: "#008177",
          load: "195,826",
          instantaneousLoad: "8,260",
          people: "5,862",
        },
        {
          backgroundColor: "#0F3C56",
          load: "195,826",
          instantaneousLoad: "8,260",
          people: "5,862",
        },
        {
          backgroundColor: "#606A3E",
          load: "195,826",
          instantaneousLoad: "8,260",
          people: "5,862",
        },
      ],
    };
  },
  computed: {
    list() {
      return [
        {
          icon: require("@/assets/images/rightNav/ticket.png"),
          hoverIcon: require("@/assets/images/rightNav/ticket.png"),
          title: this.$t("rightNav.ticket"),
          path: "/reserve/list",
          // externalLink: "https://yuyht.wgj.qz.gov.cn/static/qzmobile/",
        },
        {
          icon: require("@/assets/images/rightNav/consult.png"),
          hoverIcon: require("@/assets/images/rightNav/consult-hover.png"),
          title: this.$t("rightNav.consult"),
          path: "/consult/form",
        },
        {
          icon: require("@/assets/images/rightNav/visitor.png"),
          hoverIcon: require("@/assets/images/rightNav/visitor-hover.png"),
          title: this.$t("rightNav.visitor"),
        },
        {
          icon: require("@/assets/images/rightNav/tik-tok.png"),
          hoverIcon: require("@/assets/images/rightNav/tik-tok-hover.png"),
          title: this.$t("rightNav.tikTok"),
        },
      ];
    },
    // 景区
    // scenery() {
    //   return [
    //     this.$t("scenery.Jianglang"),
    //     this.$t("scenery.Nianbadu"),
    //     this.$t("scenery.Qingyang"),
    //   ];
    // },
    // 二维码
    qrList() {
      return [
        {
          img: require("@/assets/images/qrcode-3.png"),
          tips: this.$t("rightNav.medium.tikTokScan"),
          label: this.$t("rightNav.medium.tikTokAttention"),
        },
        {
          img: require("@/assets/images/qrcode-1.png"),
          tips: this.$t("rightNav.medium.wechatScan"),
          label: this.$t("rightNav.medium.wechatAttention"),
        },
        {
          img: require("@/assets/images/qrcode-2.png"),
          tips: this.$t("rightNav.medium.wechatScan"),
          label: this.$t("rightNav.medium.wechatAttentionTravel"),
        },
      ];
    },
  },
  created() {
    getPassengnum().then((res) => {
      this.panelList = res.data.records;
    });
  },
  methods: {
    handleClick(row) {
      row.path && this.$router.push(row.path);
      row.externalLink && window.open(row.externalLink);
    },
    updateHover(index) {
      this.listHover = index;
    },
    mouseleave() {
      this.listHover = null;
    },
    // 返回顶部
    toTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.right-nav {
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
  right: 20px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .right-gif {
    width: 56px;
    margin-bottom: -10px;
    transform: scaleX(-1);
    position: relative;
    z-index: -1;
  }

  .nav-list {
    overflow: hidden;
    border-radius: 6px;
    box-shadow: 0px 4px 7.8px 0px rgba(0, 0, 0, 0.25);
  }
  .nav-item {
    padding: 10px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    width: 68px;
    .nav-icon {
      width: 24px;
      height: 24px;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .nav-title {
      margin-top: 6px;
      color: #222;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
    }
    &:hover {
      background-color: #009d94;
      .nav-title {
        color: #fff;
      }
    }
  }
  .to-top {
    padding: 10px;
    background: #f5fefb;
    color: #222;
    font-size: 12px;
    font-weight: 400;

    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    .top-icon {
      width: 16px;
      height: 16px;
      margin-right: 6px;
      background-image: url(@/assets/images/rightNav/to-top.png);
      background-repeat: no-repeat;
      background-size: 100%;
    }
    &:hover {
      background-color: #009d94;
      color: #fff;
      .top-icon {
        background-image: url(@/assets/images/rightNav/to-top-hover.png);
      }
    }
  }
  .right-hover {
    position: absolute;
    left: -20px;
    z-index: 100;
    transform: translate(-100%, -50%);
    top: 50%;
    .hover-panel {
      padding: 12px;
      border-radius: 6px;
      background: #fff;
      .panel-item {
        width: 336px;
        padding: 12px 0;
        background: #edfcfb;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .panel-title {
          color: #222;
          font-size: 14px;
          font-weight: 400;
          background-image: url(@/assets/images/rightNav/panel-title.png);
          background-repeat: no-repeat;
          background-size: auto 100%;
          background-position: center;
          height: 32px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          margin-bottom: 12px;
        }
        .panel-content {
          display: flex;
          width: 100%;
        }
        .panel-cell {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .panel-value {
            color: #009d94;
            font-size: 16px;
            font-weight: 400;
          }
          .panel-label {
            margin-top: 4px;
            color: #666;
            font-size: 12px;
            font-weight: 400;
            text-align: center;
          }
        }
        + .panel-item {
          margin-top: 2px;
        }
        &:first-child {
          border-radius: 6px 6px 0 0;
        }
        &:last-child {
          border-radius: 0 0 6px 6px;
        }
      }
    }
    .hover-qrcode {
      padding: 12px;
      border-radius: 6px;
      background: #fff;
      display: flex;
      align-items: flex-start;
      .qrcode-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .qr-img {
          width: 110px;
          display: block;
          margin-bottom: 2px;
        }
        .qr-tips,
        .qr-label {
          text-align: center;
          color: #333;
          font-size: 12px;
          line-height: 16px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
